module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_location_maedori-efe3353f6bf01adc4a0d3d4fcb819ab8.webp";